import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EnvService } from 'src/app/env.service';

@Component({
  selector: 'app-node-history',
  templateUrl: './node-history.component.html',
  styleUrls: ['./node-history.component.css']
})
export class NodeHistoryComponent implements OnInit {

  displayedColumnsForComDcom: string[] = ['type', 'date'];
  displayedColumnsForReplacement: string[] = ['oldEid', 'newEid',"invokerId","reason","customerEmail","initiationDate","completionDate"];
  displayedColumnsForDelayModify: string[] = ['invokerId', 'reason',"time","date","status"];
  dataSourceForComDcom=[];
  dataSourceForReplacement=[];
  dataSourceForDelayModify=[];

  loading=true;
  loadingReplacement=true;
  loadingDelayModify=true;

  localData;
  localDataReplacement;
  localDataDelayModify;

  constructor(@Inject(MAT_DIALOG_DATA) public data : any, private http: HttpClient, private env: EnvService, private router: Router) { }

  ngOnInit(): void {
    // console.log("nodeHistory data "+JSON.stringify(this.data));
    this.http.get(this.env.apiUrl+"/api/users/nodeHistory/" + this.data.nodeId)
    .subscribe(response=>{
      // console.log("nodeHistory response "+JSON.stringify(response));
      this.localData = response
      this.setComDcomHistory();
      this.loading=false;
    },err=>{
      console.log(err);
      this.loading=false;
    })

    this.http.get(this.env.apiUrl+"/api/users/nodeReplacementHistory/" + this.data.nodeId)
    .subscribe(response=>{
      // console.log("nodeHistory response "+JSON.stringify(response));
      this.localDataReplacement = response
      this.setReplacementHistory();
      this.loadingReplacement=false;
    },err=>{
      console.log(err);
      this.loadingReplacement=false;
    })

    this.http.get(this.env.apiUrl+"/api/users/nodeDelayModify/" + this.data.nodeId)
    .subscribe(response=>{
      // console.log("nodeHistory response "+JSON.stringify(response));
      this.localDataDelayModify = response
      this.setDelayModify();
      this.loadingDelayModify=false;
    },err=>{
      console.log(err);
      this.loadingDelayModify=false;
    })

  }

  setComDcomHistory(){
    var comHistory=this.localData.nodeHistory.comHistory;
    var dcomHistory=this.localData.nodeHistory.dcomHistory;
    comHistory.map(item=>{
      this.dataSourceForComDcom.push({
        'type':'Commission',
        'date': item
      })
    });
    dcomHistory.map(item=>{
      this.dataSourceForComDcom.push({
        'type':'Decommission',
        'date': item
      })
    })
    this.dataSourceForComDcom.sort(function(a,b){return b.date>a.date?1:-1});
  }

  isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  setReplacementHistory(){
    var history=this.localDataReplacement.history;
    console.log("node replacement history ",history);
    
    for(var i=0;i<history.length;i++){
      let item = history[i];
      this.dataSourceForReplacement.push({
        'oldEid':item.oldNodeEid,
        'newEid': item.newNodeEid,
        'invokerId':item.invokerId,
        'reason':this.isValidEmail(item.reason) ? item.customerEmail : item.reason,
        "customerEmail":!this.isValidEmail(item.reason) ? item.customerEmail : item.reason,
        'initiationDate':item.initiationDate,
        'completionDate':item.completionDate,
        'newNodeShortId':item.newNodeShortId,
        'oldNodeShortId':item.oldNodeShortId
      })
    }
    this.dataSourceForReplacement.sort(function(a,b){return b.createdAt>a.createdAt?1:-1});
  }

  setDelayModify(){
    var history=this.localDataDelayModify.modification;
    console.log("node delay modifiaction history ",history);
    
    for(var i=0;i<history.length;i++){
      let item = history[i];
      this.dataSourceForDelayModify.push({
        'invokerId':item.invokerId,
        'reason':item.reason,
        'date':item.date,
        'time':item.time,
        "status":item.status
      })
    }
    this.dataSourceForDelayModify.sort(function(a,b){return b.date>a.date?1:-1});
  }

}
